import { DateRangeDropdownV2 } from '@/components/custom/erp';
import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

export const BasicInfoTab: React.FC = () => {
  return (
    <div className='space-y-2 p-4'>
      <div className='space-y-1'>
        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Ngày c/từ(từ/đến)</Label>
          <DateRangeDropdownV2
            fromDateName='ngay_ct1'
            toDateName='ngay_ct2'
            toFieldClassName='w-44'
            fromFieldClassName='w-44'
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Số c/từ(từ/đến)</Label>
          <FormField type='text' name='so_ct1' />
          <FormField type='text' name='so_ct2' className='ml-2' />
        </div>

        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Diễn giải</Label>
          <div className='w-full'>
            <FormField type='text' name='dien_giai' />
          </div>
        </div>
      </div>
    </div>
  );
};
